import script from "./PlanChangeCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanChangeCom.vue?vue&type=script&setup=true&lang=js"

import "./PlanChangeCom.vue?vue&type=style&index=0&id=62ea8c44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ea8c44"]])

export default __exports__